import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const PAGES = [
  { label: "Dashboard",         path: "/",                icon: "⊞" },
  { label: "Adaugă restaurant", path: "/restaurants/new", icon: "＋" },
  { label: "Conturi clienți",   path: "/client-accounts", icon: "👥" },
  { label: "Tickete suport",    path: "/tickets",          icon: "💬" },
  { label: "Noutăți",           path: "/update-notes",     icon: "📋" },
];

export default function CommandPalette({ open, onClose, restaurants = [] }) {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    if (open) { setQ(""); setTimeout(() => inputRef.current?.focus(), 50); }
  }, [open]);

  useEffect(() => {
    const fn = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") { e.preventDefault(); open ? onClose() : null; }
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [open, onClose]);

  if (!open) return null;

  const lower = q.toLowerCase().trim();

  const matchedPages = lower
    ? PAGES.filter(p => p.label.toLowerCase().includes(lower))
    : PAGES;

  const matchedRests = restaurants
    .filter(r => !lower || r.name.toLowerCase().includes(lower) || r.slug?.toLowerCase().includes(lower))
    .slice(0, 8);

  const go = (path) => { nav(path); onClose(); };

  return (
    <>
      <style>{`
        #cmd-overlay { position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2000;display:flex;align-items:flex-start;justify-content:center;padding-top:80px;animation:fadeIn .12s ease; }
        #cmd-box { width:100%;max-width:540px;background:#0f172a;border:1px solid rgba(255,255,255,.1);border-radius:14px;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.6);animation:slideDown .15s ease; }
        @keyframes slideDown { from{opacity:0;transform:translateY(-12px)} to{opacity:1;transform:translateY(0)} }
        #cmd-input { width:100%;background:transparent;border:none;outline:none;padding:16px 20px;font-size:15px;font-weight:500;color:white;font-family:inherit; }
        #cmd-input::placeholder { color:rgba(255,255,255,.3); }
        #cmd-sep { height:1px;background:rgba(255,255,255,.07); }
        #cmd-results { max-height:360px;overflow-y:auto; }
        .cmd-section { padding:8px 12px 4px;font-size:10px;font-weight:700;color:rgba(255,255,255,.3);text-transform:uppercase;letter-spacing:1px; }
        .cmd-item { display:flex;align-items:center;gap:12px;padding:10px 16px;cursor:pointer;transition:background .1s;border-radius:0; }
        .cmd-item:hover,.cmd-item.active { background:rgba(255,255,255,.07); }
        .cmd-icon { width:28px;height:28px;border-radius:7px;background:rgba(255,255,255,.08);display:flex;align-items:center;justify-content:center;font-size:13px;flex-shrink:0; }
        .cmd-label { font-size:13px;font-weight:600;color:rgba(255,255,255,.85); }
        .cmd-sub { font-size:11px;color:rgba(255,255,255,.35);margin-top:1px; }
        .cmd-badge { margin-left:auto;font-size:10px;font-weight:700;padding:2px 8px;border-radius:100px;flex-shrink:0; }
        .cmd-rest-icon { width:28px;height:28px;border-radius:7px;background:#1d4ed8;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:800;color:white;flex-shrink:0; }
        #cmd-footer { padding:8px 16px;border-top:1px solid rgba(255,255,255,.07);display:flex;gap:12px; }
        .cmd-hint { font-size:11px;color:rgba(255,255,255,.25);display:flex;align-items:center;gap:4px; }
        .cmd-hint kbd { background:rgba(255,255,255,.08);padding:1px 6px;border-radius:4px;font-family:monospace;font-size:10px; }
      `}</style>

      <div id="cmd-overlay" onClick={onClose}>
        <div id="cmd-box" onClick={e => e.stopPropagation()}>
          <input
            ref={inputRef}
            id="cmd-input"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Caută restaurant sau pagină..."
          />
          <div id="cmd-sep"/>
          <div id="cmd-results">
            {matchedPages.length > 0 && (
              <>
                <div className="cmd-section">Pagini</div>
                {matchedPages.map(p => (
                  <div key={p.path} className="cmd-item" onClick={() => go(p.path)}>
                    <div className="cmd-icon">{p.icon}</div>
                    <div><div className="cmd-label">{p.label}</div></div>
                    <span className="cmd-badge" style={{ background:"rgba(255,255,255,.07)",color:"rgba(255,255,255,.35)" }}>pagină</span>
                  </div>
                ))}
              </>
            )}
            {matchedRests.length > 0 && (
              <>
                <div className="cmd-section">Restaurante</div>
                {matchedRests.map(r => {
                  const isOverdue = r.billingStatus === "overdue";
                  const isPaid    = r.billingStatus === "paid";
                  return (
                    <div key={r._id} className="cmd-item" onClick={() => go(`/restaurants/${r._id}`)}>
                      <div className="cmd-rest-icon">{r.name.charAt(0).toUpperCase()}</div>
                      <div style={{ flex:1,minWidth:0 }}>
                        <div className="cmd-label">{r.name}</div>
                        <div className="cmd-sub">{r.slug}.orderly.ro</div>
                      </div>
                      {isOverdue && <span className="cmd-badge" style={{ background:"rgba(220,38,38,.2)",color:"#fca5a5" }}>restanță</span>}
                      {isPaid    && <span className="cmd-badge" style={{ background:"rgba(5,150,105,.2)",color:"#6ee7b7" }}>plătit</span>}
                      {!isOverdue && !isPaid && r.billingStatus === "pending" && <span className="cmd-badge" style={{ background:"rgba(217,119,6,.15)",color:"#fcd34d" }}>în așteptare</span>}
                      {!r.isActive && <span className="cmd-badge" style={{ background:"rgba(255,255,255,.06)",color:"rgba(255,255,255,.3)" }}>inactiv</span>}
                    </div>
                  );
                })}
              </>
            )}
            {matchedPages.length === 0 && matchedRests.length === 0 && (
              <div style={{ padding:"32px 20px",textAlign:"center",color:"rgba(255,255,255,.3)",fontSize:13 }}>
                Niciun rezultat pentru „{q}"
              </div>
            )}
          </div>
          <div id="cmd-footer">
            <span className="cmd-hint"><kbd>↑↓</kbd> navighează</span>
            <span className="cmd-hint"><kbd>↵</kbd> deschide</span>
            <span className="cmd-hint"><kbd>Esc</kbd> închide</span>
          </div>
        </div>
      </div>
    </>
  );
}
